import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77a3e620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-slide-list" }

import { computed, PropType, provide } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { injectKeySlideScale } from '@/types/injectKey'
import { VIEWPORT_SIZE } from '@/configs/canvas'

import ScreenSlide from './ScreenSlide.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenSlideList',
  props: {
  slideWidth: {
    type: Number,
    required: true,
  },
  slideHeight: {
    type: Number,
    required: true,
  },
  animationIndex: {
    type: Number,
    required: true,
  },
  turnSlideToId: {
    type: Function as PropType<(id: string) => void>,
    required: true,
  },
  manualExitFullscreen: {
    type: Function as PropType<() => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { slides, slideIndex, currentSlide } = storeToRefs(useSlidesStore())

const scale = computed(() => props.slideWidth / VIEWPORT_SIZE)
provide(injectKeySlideScale, scale)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
        'slide-item', 
        `turning-mode-${slide.turningMode || 'slideY'}`,
        {
          'current': index === _unref(slideIndex),
          'before': index < _unref(slideIndex),
          'after': index > _unref(slideIndex),
          'hide': (index === _unref(slideIndex) - 1 || index === _unref(slideIndex) + 1) && slide.turningMode !== _unref(currentSlide).turningMode,
        }
      ]),
        key: slide.id
      }, [
        (Math.abs(_unref(slideIndex) - index) < 2 || slide.animations?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "slide-content",
              style: _normalizeStyle({
          width: __props.slideWidth + 'px',
          height: __props.slideHeight + 'px',
        })
            }, [
              _createVNode(ScreenSlide, {
                slide: slide,
                scale: _unref(scale),
                animationIndex: __props.animationIndex,
                turnSlideToId: __props.turnSlideToId,
                manualExitFullscreen: __props.manualExitFullscreen
              }, null, 8, ["slide", "scale", "animationIndex", "turnSlideToId", "manualExitFullscreen"])
            ], 4))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})